import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { FixturePricingState } from '@cds/betting-offer/add-ons';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { HorsesMeetingAllRaceViewModel, WinGameFixturePreview } from '@frontend/sports/racing/feature/models';

@Component({
    selector: 'ms-meeting',
    templateUrl: 'meeting.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class MeetingComponent {
    @Input() races: HorsesMeetingAllRaceViewModel[];
    @Output() fixtureClick = new EventEmitter<WinGameFixturePreview>();

    pricingStates = {
        Resulted: FixturePricingState.Resulted,
        Priced: FixturePricingState.Priced,
        RaceOff: FixturePricingState.RaceOff,
        None: FixturePricingState.None,
    };

    constructor(public sitecore: Sitecore) {}

    onFixtureClick(raceFixture: WinGameFixturePreview) {
        this.fixtureClick.emit(raceFixture);
    }
}
